'use client';

import * as Sentry from '@sentry/nextjs';
import { type FunctionComponent, useEffect } from 'react';

interface Props {
  userId: string;
  email: string;
  name: string | null;
}

// Mount once in the root layout (server component passes session data as
// props) to give Sentry user context for all client-side error reports.
const SentryUserInit: FunctionComponent<Props> = ({ userId, email, name }) => {
  useEffect(() => {
    Sentry.setUser({ id: userId, email, username: name ?? undefined });
  }, [userId, email, name]);
  return null;
};

export default SentryUserInit;
